import { IAutomationObject } from '../../types'

export interface IMultiStateSwitch extends IAutomationObject {
    actState: number;
    actStateText: string;
    stateTextList: string;
    isMan: boolean;
    resetMan: boolean;
}


export const schema = 'AutomationApps.Devices.Commons.MultiStateSwitch';